const state = {
  tasks: [],
  tasksCategories: [],
  priorities: [],
  customerTasks: [],
  employeeTasks: []
};
const mutations = {
  SET_DOD_TASKS(state, tasks) {
    state.tasks = tasks
  },
  SET_DOD_TASKS_CATEGORIES(state, categories) {
    state.tasksCategories = categories
  },
  SET_DOD_TASKS_PRIORITY(state, priorities) {
    state.priorities = priorities
  },
  SET_DOD_CUSTOMER_TASKS(state, tasks) {
    state.customerTasks = tasks
  },
  SET_DOD_EMPLOYEE_TASKS(state, tasks) {
    state.employeeTasks = tasks
  }
};
const getters = {
  getDodTasks: state => state.tasks,
  getDodTasksCategories: state => state.tasksCategories,
  getDodTasksPriorities: state => state.priorities,
  getDodCustomerTasks: state => state.customerTasks,
  getDodEmployeeTasks: state => state.employeeTasks
};

export default {
  state,
  mutations,
  getters,
};